import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";
import Select from 'react-select'
import {useNavigate, useSearchParams} from "react-router-dom";

import {MDBTextArea, MDBBtn, MDBCheckbox} from "mdb-react-ui-kit";

import DatePicker, { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import de from "date-fns/locale/de";
import Moment from 'moment';
import {backendPathCustomers, backendPathEmployees, backendPathTasks} from "../Constants";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


registerLocale("de", de);
Moment.locale('de');


function NewTask() {
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams({employeeId: "", customerId: ""});

    const [employees, setEmployees] = useState([]);
    const [customers, setCustomers] = useState([]);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [employeeId, setEmployeeId] = useState(0);
    const [employeeLabel, setEmployeeLabel] = useState("");
    const [customerId, setCustomerId] = useState(0);
    const [customerLabel, setCustomerLabel] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [noEmployeeNeeded, setNoEmployeeNeeded] = useState(false);

    const [submitted, setSubmitted] = useState(false);
    const [overlapping, setOverlapping] = useState(false);
    const [overlappingTasks, setOverlappingTasks] = useState(new Date());

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getEmployees = () => {
        console.log("get empls");
        Axios.get(backendPathEmployees+"employees-overview.php").then((response) => {
            console.log("emp overv");
            console.log(response.data);

            setEmployees(response.data.map((val, key) => {
                return {label: val.FirstName+' '+val.LastName, value: val.EmployeeID };
            }));
        });
    };

    const getCustomers = () => {
        Axios.get(backendPathCustomers+"customers-overview.php").then((response) => {
            setCustomers(response.data.map((val, key) => {
                return {label: val.FirstName+' '+val.LastName, value: val.CustomerID };
            }));
        });
    };

    const validateTask = () => {
        setSubmitted(true);

        if (!checkCompleteness()) {
            return;
        }

        if (Moment(startDate).isAfter(Moment(endDate))) {
            return;
        }

        // check for overlapping
        Axios.get(`${backendPathTasks}check-task-overlapping.php?customerId=${customerId}&employeeId=${employeeId}&firstDay=${Moment(startDate).format('YYYY-MM-DD')}&lastDay=${Moment(endDate).format('YYYY-MM-DD')}`).then((response) => {
            console.log("drin");
            console.log(response.data);

            // check task amount

            const taskLength = Math.round((new Date(endDate) - new Date(startDate)) / (1000 * 3600 * 24) + 1);
            var tasksPerDay = [];
            var day = new Moment(startDate);

            for (let i=0; i < taskLength; i++) {
                tasksPerDay.push({date: day.format('YYYY-MM-DD'), taskIDs: []});
                for (let k=0; k < response.data.length; k++) {
                    if (Moment(day.format('YYYY-MM-DD')).isSameOrBefore(response.data[k].EndDate) && Moment(day.format('YYYY-MM-DD')).isSameOrAfter(response.data[k].StartDate)) {
                        tasksPerDay[i].taskIDs.push(response.data[k].TaskID);
                    }
                }

                // already 2 tasks on an included date
                if (tasksPerDay[i].taskIDs.length > 1) {
                    setOverlapping(true);
                    setOverlappingTasks(response.data.filter((x) => x.TaskID === tasksPerDay[i].taskIDs[0] || x.TaskID === tasksPerDay[i].taskIDs[1]));
                    return;
                }

                console.log(day.format('YYYY-MM-DD'));
                day.add(1, 'days');
            }
            console.log(tasksPerDay);

            
            // check overlapping lengths

            var overlapping_ids = new Set();

            for (let i=0; i < response.data.length; i++) {
                const sa = Moment(Moment(startDate).format('YYYY-MM-DD'));
                const ea = Moment(Moment(endDate).format('YYYY-MM-DD'));
                const sb = Moment(Moment(response.data[i]["StartDate"]).format('YYYY-MM-DD'));
                const eb = Moment(Moment(response.data[i]["EndDate"]).format('YYYY-MM-DD'));

                const overlapping_len = sa.isBefore(sb) ? sb.diff(ea, 'days') : sa.diff(eb, 'days');
                console.log(overlapping_len);

                if (overlapping_len > 3) {
                    overlapping_ids.add(response.data[i]["TaskID"]);
                }
            }

            console.log(overlapping_ids);
            if (overlapping_ids.size > 0) {
                setOverlapping(true);
                setOverlappingTasks(response.data.filter((x) => overlapping_ids.has(x.TaskID) ));
                return;
            }
            
            setOverlapping(false);
            addTask();
        });
    }

    const checkCompleteness = () => {
        console.log(customerId);
        if (!customerId || (!employeeId && !noEmployeeNeeded) || !(startDate instanceof Date) || isNaN(startDate) || !(endDate instanceof Date) || isNaN(endDate)) {
            console.log("not complete");
            return false;
        }
        return true;
    };

    const addTask = () => {
        Axios.get(backendPathTasks+"create-task.php", {
            params: {
                startDate: Moment(startDate).format("YYYY-MM-DD"),
                endDate: Moment(endDate).format("YYYY-MM-DD"),
                customerId: customerId,
                employeeId: noEmployeeNeeded ? -1 : employeeId,
                annotation: annotation,
            }
        }).then(() => {
            console.log(Moment(startDate).format('DD-MM-YYYY'), Moment(endDate).format('DD-MM-YYYY'), customerId, employeeId, annotation);
            navigate("/");
        });
    };

    useEffect(() => {
        getEmployees();
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        console.log(employees)
        if (employees.length > 0 && searchParams.get("employeeId") !== "") {
            const employee = employees.find(e => {
                return e.value === searchParams.get("employeeId");
            });
            if (employee) {
                setEmployeeId(Number(employee.value))
                setEmployeeLabel(employee.label)
            }
        }
        getCustomers();
    }, [employees]);

    useEffect(() => {
        if (customers.length > 0 && searchParams.get("customerId") !== "") {
            const customer = customers.find(c => {
                return c.value === searchParams.get("customerId");
            });
            if (customer) {
                setCustomerId(Number(customer.value))
                setCustomerLabel(customer.label)
            }
        }
    }, [customers]);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className="main">
                <div className="header">
                    <h2>Neuen Einsatz planen</h2>
                </div>

                <div className='input-form'>

                    {(submitted && overlapping) ?
                        <div>
                            <p className="validation-label">Es gibt eine Überschneidung mit folgenden Einsätzen:</p>
                            {overlappingTasks.map((val, key) => {
                                console.log(val);
                                return (
                                    <p className="validation-label" key={key}>
                                        {Moment(val.StartDate).format('DD.MM.YY')} - {Moment(val.EndDate).format('DD.MM.YY')}:
                                        {
                                            val.FirstNameE === null && val.LastNameE === null ?
                                                " keine Betreuung notwendig" :
                                                ` ${val.FirstNameE} ${val.LastNameE} betreut ${val.FirstNameC} ${val.LastNameC}`
                                        }
                                    </p>
                                );
                            })}
                        </div>
                        : null
                    }

                    <p className="input-label">Startdatum</p>
                    <DatePicker className="date-input-1" locale="de" dateFormat='dd.MM.yyyy' selected={startDate}
                                onChange={date =>
                                    setStartDate(date)}
                    />
                    {(submitted && Moment(startDate).isAfter(Moment(endDate))) ?
                        <p className="validation-label-date">Startdatum darf nicht nach Enddatum liegen.</p> : null
                    }
                    {(submitted && (!(startDate instanceof Date) || isNaN(startDate))) ?
                        <p className="validation-label-date">Startdatum ist nicht gültig.</p> : null
                    }

                    <p className="input-label">Enddatum</p>
                    <DatePicker className="date-input-1" locale="de" dateFormat='dd.MM.yyyy' minDate={startDate}
                                selected={endDate} onChange={date =>
                        setEndDate(date)}
                    />
                    {(submitted && (!(endDate instanceof Date) || isNaN(endDate))) ?
                        <p className="validation-label-date">Enddatum ist nicht gültig.</p> : null
                    }

                    <p className="input-label">Kunde/in</p>
                    <Select className="input" id="select1" placeholder={'Auswählen...'} options={customers}
                            value={customerId ? {label: customerLabel, value: customerId} : null} onChange={(event) => {
                        setCustomerId(event.value);
                        setCustomerLabel(event.label);
                    }}/>
                    {(submitted && !customerId) ?
                        <p className="validation-label">Kunde darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Betreuungskraft</p>
                    <Select className="input"
                            id="select2"
                            placeholder={'Auswählen...'}
                            options={employees}
                            value={employeeId ? {label: employeeLabel, value: employeeId} : null}
                            isDisabled={noEmployeeNeeded}
                            onChange={(event) => {
                                setEmployeeId(event.value);
                                setEmployeeLabel(event.label)
                            }}/>
                    {(submitted && !employeeId && !noEmployeeNeeded) ?
                        <p className="validation-label">Betreuer darf nicht leer sein.</p> : null
                    }

                    <div className="input">
                        <MDBCheckbox
                            checked={noEmployeeNeeded}
                            label="keine Betreuung notwendig"
                            onChange={
                                (event) => {
                                    setNoEmployeeNeeded(event.target.checked);
                                    if (event.target.checked) {
                                        setEmployeeId(0);
                                        setEmployeeLabel("");
                                    }
                                }
                            }
                        />
                    </div>

                    <MDBTextArea className="input" label='Anmerkung' id='textAreaExample' rows={4}
                                 onChange={(event) => {
                                     setAnnotation(event.target.value);
                                 }}/>
                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={validateTask}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default NewTask;